import React from "react";
import { useSelector } from "react-redux";
import ContactForm from "../ContactFormModal/ContactForm";
import KnowMore from "./KnowMore";
import "./styles.scss";

const AgentBusinessCardMini = ({
  withKnowMore,
  withForm,
  onContactAgent,
  onCancelForm,
  onSubmitForm,
  shareLink,
}) => {
  const agentProfile = useSelector((store) => store.profile.agent);
  const settings = useSelector((store) => store.profile.settings);

  if (!agentProfile) return null;

  return (
    <div className="dyna-box agent-card-over">
      <div className="agent">
        <div className="photo-name">
          {agentProfile.AgentPhotoMiniUrl && (
            <div className="dyna-photo-width">
              <div
                className="dyna-bg-img-round"
                style={{
                  backgroundImage: `url(${agentProfile.AgentPhotoMiniUrl})`,
                }}
              />
            </div>
          )}
          <div className="agent-name">
            {!agentProfile.Team && (
              <div className="agent-name_header">
                {agentProfile.FirstName} {agentProfile.LastnName}
              </div>
            )}
            {agentProfile.Team && (
              <div className="agent-name_header">
                {agentProfile.Team.AssigneeName ? (
                  <div>
                    <div>{agentProfile.Team.AssigneeName}</div>
                    <div className="ft-wt-nl">On Behalf Of</div>
                    <div className="ft-wt-nl">
                      {agentProfile.Team.DisplayName}
                    </div>
                  </div>
                ) : (
                  agentProfile.Team.DisplayName
                )}
              </div>
            )}
            <div className="agent-name_subheader">{agentProfile.Title}</div>
          </div>
        </div>
        <div className="agent-info">
        {agentProfile.CellPhone && (
          <div className="agent-name_subheader">
            Cell: {agentProfile.CellPhone}{" "}
          </div>
        )}
        {agentProfile.DirectLinePhone && (
          <div className="agent-name_subheader">
            Direct: {agentProfile.DirectLinePhone}{" "}
          </div>
        )}
        {agentProfile.HomePhone && (
          <div className="agent-name_subheader">
            Home: {agentProfile.HomePhone}{" "}
          </div>
        )}
        {agentProfile.FaxNumber && (
          <div className="agent-name_subheader">
            Fax: {agentProfile.FaxNumber}{" "}
          </div>
        )}
        {agentProfile.PagerNumber && (
          <div className="agent-name_subheader">
            Pager: {agentProfile.PagerNumber}{" "}
          </div>
        )}
        {agentProfile.OfficePhone && (
          <div className="agent-name_subheader">
            Office: {agentProfile.OfficePhone}{" "}
          </div>
        )}        
        {agentProfile.OfficeFaxnumber && (
          <div className="agent-name_subheader">
            Office Fax: {agentProfile.OfficeFaxnumber}{" "}
          </div>
        )}                  
        {agentProfile.DreNumber && (
          <div className="agent-name_subheader">
            {settings.DRENumberDisplayName}: {agentProfile.DreNumber}{" "}
          </div>
        )}
        {agentProfile.Email && (
          <div className="agent-name_subheader">
            <div className="email-info">
              <span>Email:</span>{" "}
              <a href={`mailto:${agentProfile.Email}`}>{agentProfile.Email}</a>
            </div>
          </div>
        )} 
        {agentProfile.SecondEmail && (
          <div className="agent-name_subheader">
            <div className="email-info">
              <span>Email:</span>{" "}
              <a href={`mailto:${agentProfile.SecondEmail}`}>{agentProfile.SecondEmail}</a>
            </div>
          </div>
        )}               
        </div>
      </div>
      {(withKnowMore || withForm) && (
        <div className="form-container">
          {withKnowMore && (
            <KnowMore
              shareLink={shareLink}
              agentName={agentProfile.FirstName}
              onContactAgent={onContactAgent}
            />
          )}
          {withForm && (
            <ContactForm onCancel={onCancelForm} onSubmit={onSubmitForm} />
          )}
        </div>
      )}
    </div>
  );
};

export default AgentBusinessCardMini;
